export default __webpack_public_path__ + "static/petiteMaro.en.cover-187673984c55d0cb4bc03bf9142a301f.jpg";